import { IconProps } from "../../utils/global-types/global-types";

const OutboundIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className || "w-5 h-5"}
    fill="none"
    viewBox="0 0 18 18"
  >
    <path
      className="fill-[#252B37] dark:fill-white"
      d="M11.968 1.917c2.578 0 4.115 1.537 4.108 4.115v5.936c0 2.578-1.537 4.115-4.115 4.115H6.032c-2.578 0-4.115-1.537-4.115-4.122V6.032c0-2.578 1.537-4.115 4.115-4.115z"
    ></path>
    <path
      className="fill-[#fff] dark:fill-[#252B37]"
      d="M11.5 6.5a.567.567 0 0 0-.8 0l-4.8 4.8a.566.566 0 0 0 .8.8l4.8-4.8a.567.567 0 0 0 0-.8"
    ></path>
    <path
      className="fill-[#fff] dark:fill-[#252B37]"
      d="M11.5 6.5a.56.56 0 0 0-.4-.166H7.9a.566.566 0 1 0 0 1.132h2.634V10.1a.566.566 0 0 0 1.132 0V6.9a.56.56 0 0 0-.166-.4"
    ></path>
  </svg>
  );
};

export default OutboundIcon;
